import { ToasterPlacement } from '~/astra'
import env from '~/env'
import { useStore } from '~/store/store'

export const Toaster = () => {
    const toasts = useStore(state => state.toaster.toasts)
    const removeToast = useStore(state => state.toaster.actions.removeToast)

    return <ToasterPlacement toasts={toasts} onClose={removeToast} noUnstableEffects={env.VITE_NO_UNSTABLE_EFFECTS} />
}
